import React from 'react';
import type { RadarState } from '../types/radar.types';

interface RadarLoadingOverlayProps {
  radarState: RadarState;
  onRetry: () => void;
}

const RadarLoadingOverlay: React.FC<RadarLoadingOverlayProps> = ({ radarState, onRetry }) => {
  if (radarState.status === 'idle' || radarState.status === 'loaded') return null;

  return (
    <div className="absolute top-[90px] right-[70px] z-[999]">
      {radarState.status === 'loading' && (
        <div className="bg-white rounded-lg shadow-lg px-4 py-3 flex items-center gap-3 min-w-[200px]">
          <div className="w-5 h-5 border-2 border-[#078CB3] border-t-transparent rounded-full animate-spin" />
          <div className="text-sm font-semibold text-[#232B36]">Loading Radar...</div>
        </div>
      )}

      {radarState.status === 'precaching' && (
        <div className="bg-white rounded-lg shadow-lg px-4 py-3 min-w-[220px]">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-5 h-5 border-2 border-[#078CB3] border-t-transparent rounded-full animate-spin" />
            <div className="text-sm font-semibold text-[#232B36]">
              Pre-loading {radarState.precacheProgress}/{radarState.totalCount}
            </div>
          </div>
          <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-full bg-[#078CB3] rounded-full transition-all duration-300"
              style={{
                width: `${(radarState.precacheProgress / radarState.totalCount) * 100}%`,
              }}
            />
          </div>
        </div>
      )}

      {radarState.status === 'error' && (
        <div className="bg-white rounded-lg shadow-lg px-4 py-3 flex items-center gap-2 min-w-[220px]">
          <div className="w-5 h-5 flex items-center justify-center">
            <svg className="w-5 h-5 text-[#F46A6A]" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <span className="text-sm text-[#F46A6A]">
            {radarState.errorMessage || 'Radar connection failed'}
          </span>
          <button
            className="ml-2 text-xs text-[#078CB3] hover:underline font-semibold"
            onClick={onRetry}
          >
            Retry
          </button>
        </div>
      )}
    </div>
  );
};

export default RadarLoadingOverlay;
